interface Props {
  value: string;
}

export const AttributeValue = ({ value }: Props) => {
  return <div className="line-clamp-2 text-left body-5">{value}</div>;
};
